module.exports = __webpack_public_path__ + "3fad2c870be8a96e29324a9aa430862c.png";